export const TEMPLATES_CONSTANTS = {
    MAIL_VENDOR: '66752bc6d8c1cd06f3d18b5c',
    MAIL_OTP: '66785c9068a49bf65cbc102c',
    MAIL_SCRUMBOARD_TASK_ASSIGNMENT: '667ba8c61a0f9a6cbdbbdd36',
    MAIL_TM_SPA: '6735a3ddac5c8374fb9e95ed' 
};
